module.exports = __webpack_public_path__ + "img/printsign.b168afae.png";